import Axios from 'axios'
import Cookies from 'universal-cookie'

const URL = process.env.REACT_APP_BACK_END_URL

const apiInstance = Axios.create({
    baseURL: `${URL}`
})

const cookies = new Cookies();

apiInstance.interceptors.request.use((config) => {
    const jwtCookie = cookies.get('jwt');
    if (jwtCookie) {
        config.headers.Authorization = `Bearer ${jwtCookie}`;
    }
    return config;
});


//User
const UserLogin = async (userName, password) => {
    const data = {
        userName: userName,
        password: password
    }

    try {
        const res = await Axios.post(`${URL}/Login`, data)

        if (res) {
            return res
        } else {
            console.log('no response')
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }
}


//Google User
const UserLoginGoogle = async (token) => {
    try {
        const headers = {
            'Authorization': `Bearer ${token}`
        }

        const res = await Axios.post(`${URL}/Google-Login`, { userName: null }, {
            headers: headers,
        });

        if (res) {
            return res
        } else {
            console.log("Could not log in")
            return null
        }

    } catch (err) {
        console.log(err)
        return null
    }

}

const CreateUser = async (data) => {
    try {
        const res = await Axios.post(`${URL}/User`, data)

        if (res) {
            return res
        } else {
            console.log('could not create user')
        }
    } catch (err) {
        console.log(err)
        return null
    }

}

const GetUser = async (id) => {
    try {
        const res = await Axios.get(`${URL}/User`, { params: { id: id } })

        if (res) {
            return res
        } else {
            console.log('could not find user with id:', id)
        }
    } catch (err) {
        console.log("ERROR", err)
        return null
    }
}

const ForgotPassword = async (email) => {
    try {
        const res = await Axios.put(`${URL}/User/Forgot?email=${email}`)
        if (res) {
            return res
        } else {
            console.log('could not find user', email)
            return null
        }
    } catch (error) {
        console.log(error)
        return null
    }
}

const ResetPasswordPut = async (token, data) => {
    try {
        const res = await Axios.put(`${URL}/User/Reset?token=${token}`, data)
        if (res) {
            return res
        } else {
            console.log('Could not reset password')
            return null
        }
    } catch (error) {
        return null
    }
}


const UpdateUser = async (user) => {
    try {
        const res = await apiInstance.put(`/User`, user)

        if (res) {
            return res
        } else {
            console.log('User was not updated')
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

const UserAcceptCookies = async (userId) => {
    try {
        const res = await Axios.put(`${URL}/User/Cookies?userId=${userId}`)

        if (res) {
            return res
        } else {
            console.log('Cookies were not updated')
        }
    } catch (error) {
        console.log(error)
        return null
    }
}

const GetAllUsers = async () => {
    try {
        const res = await apiInstance.get('/User/All')

        if (res && res.data) {
            return res.data
        } else {
            console.log('Could not get all users')
            return null
        }
    } catch (err) {
        console.log("error", err)
        return null
    }
}

const DeleteUser = async (user) => {
    try {
        const res = await apiInstance.delete(`/User?userId=${user._id}`)

        if (res && res.data) {
            return res.data
        } else {
            return null
        }

    } catch (error) {
        console.log(error)
        return null
    }
}

//League
const GetLeagueByName = async (name) => {
    try {
        const res = await apiInstance.get(`/League/Name`, { params: { name: name } })

        if (res) {
            return res
        } else {
            console.log('Could not find league with name: ', name)
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

const GetLeaguesByIds = async (ids) => {
    try {
        const res = await apiInstance.post(`/League/Id`, ids)

        if (res) {
            return res
        } else {
            console.log('Could not find any league for the provided Ids:', ids)
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

const GetLeagues = async () => {
    try {
        const res = await apiInstance.get(`/League/All`)

        if (res) {
            return res
        } else {
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

const GetLeaderboard = async (leagueId) => {
    try {
        const res = await apiInstance.get(`/Leaderboard?leagueId=${leagueId}`)
        if (res) {
            return res
        } else {
            return null
        }

    } catch (error) {
        return null
    }
}

const CreateLeague = async (data) => {
    try {
        const res = await apiInstance.post(`/League`, data)
        if (res) {
            return res
        } else {
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

const DeleteLeague = async (leagueId) => {
    try {
        const res = await apiInstance.delete(`/League`, { params: { leagueId: leagueId } })
        if (res) {
            return res
        } else {
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

const EditLeague = async (data, userId) => {
    try {
        const res = await apiInstance.put(`/League?leagueId=${data.leagueId}&userId=${userId}`, data)
        if (res) {
            return res
        } else {
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

const LeaveLeague = async (leagueId, userId, teamId) => {
    try {
        const res = await apiInstance.delete(`/Team?leagueId=${leagueId}&teamId=${teamId}&userId=${userId}`)
        if (res) {
            return res
        } else {
            console.log('Could not find riders')
            return null
        }
    } catch (error) {
        console.log(error)
        return null
    }
}

//Rider
const GetRiders = async () => {
    try {
        const res = await apiInstance.get(`/Riders`)

        if (res) {
            return res
        } else {
            console.log('Could not find riders')
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

const AddRider = async (data) => {
    try {
        const res = await apiInstance.post('/Rider', data)

        if (res) {
            return res
        } else {
            console.log("Could not add rider")
            return null
        }
    } catch (error) {
        console.log(error)
        return null
    }
}


//Result
const AddResult = async (data) => {
    try {
        const res = await apiInstance.post(`/Result`, data)

        if (res) {
            return res
        } else {
            console.log('Could not add result')
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

const GetResults = async () => {
    try {
        const res = await apiInstance.get(`/Results`)

        if (res) {
            return res
        } else {
            console.log('Could not get results')
            return null
        }
    } catch (error) {
        console.log(error)
        return null
    }
}

const GetOverallStandings = async () => {
    try {
        const res = await apiInstance.get(`/Results/Overall`)

        if (res) {
            return res
        } else {
            console.log('Could not get results')
            return null
        }
    } catch (error) {
        console.log(error)
        return null
    }
}

const GetResultsForTeam = async (teamId) => {
    try {
        const res = await apiInstance.get(`/Results/Team?teamId=${teamId}`)
        if (res) {
            return res
        } else {
            console.log('Could not get results')
            return null
        }

    } catch (error) {
        console.log(error)
        return null
    }
}



//Team
const AddTeam = async (data) => {
    try {
        const res = await apiInstance.post(`/Team`, data)

        if (res) {
            return res
        } else {
            console.log('Could not create team')
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }

}

const GetTeam = async (id) => {
    try {
        const res = await apiInstance.get(`/Team`, { params: { id: id } })

        if (res) {
            return res
        } else {
            console.log('Could not get team', id)
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }

}

const UpdateTeam = async (data) => {
    try {
        const res = await apiInstance.put(`/Team`, data)

        if (res) {
            return res
        } else {
            console.log('Could not update team')
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }

}

const GetTeamRiders = async (id) => {
    try {
        const res = await apiInstance.get(`/Team/Riders`, { params: { id: id } })
        if (res) {
            return res
        } else {
            console.log('Could no get riders for team')
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

const GetMatchingTeams = async (team) => {
    try {
        const res = await apiInstance.post(`/Team/MatchingTeams`, team)
        if (res) {
            return res
        } else {
            console.log('Could no get matching teams')
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

//Event
const SaveEvent = async (data) => {
    try {
        const res = await apiInstance.post(`/Event`, data)
        if (res) {
            return res
        } else {
            return null
        }
    } catch (err) {
        return null
    }
}

const GetEvents = async () => {
    try {
        const res = await apiInstance.get(`/Events`)
        if (res) {
            return res
        } else {
            return null
        }
    } catch (err) {
        return null
    }
}

const GetNextEvent = async () => {
    try {
        const res = await apiInstance.get('/Event/Next')
        if (res) {
            return res
        } else {
            return null
        }
    } catch (error) {
        return null
    }
}

const DeleteEvent = async (eventId) => {
    try {
        const res = await apiInstance.delete(`/Event?EventId=${eventId}`)
        if (res) {
            return res
        } else {
            return null
        }
    } catch (error) {
        console.log(error)
        return null
    }
}

//Admin
const MakeAdmin = async (userId, scope) => {
    try {
        const res = await apiInstance.post(`/Admin/User/Scope?userId=${userId}`, { scope: scope })

        if (res) {
            return res
        } else {
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

const CleanUpUsers = async () => {
    try {
        const res = await apiInstance.delete(`/DuplicateTeams`)

        if (res) {
            return res
        } else {
            return null
        }
    } catch (error) {
        console.log(error)
        return null
    }
}

const UploadResult = async (data, raceType, eventId) => {
    try {

        const formData = new FormData()
        formData.append('csv', data, data.name)
        const res = await apiInstance.post(`/Admin/Upload?raceType=${raceType}&eventId=${eventId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    } catch (error) {
        console.log(error)
        return null
    }
}

const CreateDisabled = async () => {
    try {
        const res = await apiInstance.post('/Admin/Disabled')

        if (res) {
            return res
        } else {
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }
}

const UpdateDisabled = async (disabled) => {
    try {
        const res = await apiInstance.put('/Admin/Disabled', { disabled: disabled })

        if (res) {
            return res
        } else {
            return null
        }
    } catch (error) {
        console.log(error)
        return null
    }
}

const GetDisabled = async () => {
    try {
        const res = await apiInstance.get('/Admin/Disabled')

        if (res) {
            return res
        } else {
            return null
        }
    } catch (error) {
        console.log(error)
        return null
    }
}

const DisableEditing = async () => {
    try {
        const res = await apiInstance.put('/Admin/Disabled', { disabled: true })

        if (res) {
            return res
        } else {
            return null
        }
    } catch (error) {
        console.log(error)
        return null
    }
}


//Snapshots
const GetSnapshots = async () => {
    try {
        const res = await apiInstance.get('/Snapshot/All')

        if (res) {
            return res
        } else {
            return null
        }
    } catch (error) {
        console.log(error)
    }
}

const CreateSnapshot = async (eventId, name) => {
    try {
        const res = await apiInstance.post(`/Snapshot/All?eventId=${eventId}&name=${name}`)
        if (res) {
            return res
        } else {
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }
}



const DeleteAllSnapshots = async () => {
    try {
        const res = await apiInstance.delete('/Snapshot/All')
        if (res) {
            return res
        } else {
            return null
        }
    } catch (error) {
        console.log(error)
    }
}

const DeleteSnapshotsByName = async (name) => {
    try {
        const res = await apiInstance.delete(`/Snapshots/Name?name=${name}`)
        if (res) {
            return res
        } else {
            return null
        }
    } catch (error) {
        console.log(error)
    }
}

//Analytics
const GetGlobalTopRiders = async () => {
    try{
        const res = await apiInstance.get('/Analytic/Global')
        if (res) {
            return res
        } else {
            return null
        }
    } catch (err) {
        console.log(err)
        return null
    }
}


export {
    //User
    UserLogin,
    UserLoginGoogle,
    CreateUser,
    GetUser,
    UpdateUser,
    UserAcceptCookies,
    ForgotPassword,
    ResetPasswordPut,
    GetAllUsers,
    DeleteUser,

    //League
    GetLeagueByName,
    GetLeaguesByIds,
    GetLeagues,
    GetLeaderboard,
    CreateLeague,
    EditLeague,
    DeleteLeague,
    LeaveLeague,

    //Rider
    GetRiders,
    AddRider,

    //Result
    AddResult,
    GetResults,
    GetOverallStandings,
    GetResultsForTeam,

    //Team
    AddTeam,
    GetTeam,
    UpdateTeam,
    GetTeamRiders,
    GetMatchingTeams,

    //Event
    SaveEvent,
    GetEvents,
    DeleteEvent,
    GetNextEvent,

    //Admin
    MakeAdmin,
    CleanUpUsers,
    UploadResult,
    UpdateDisabled,
    CreateDisabled,
    GetDisabled,
    DisableEditing,

    //Snapshot
    GetSnapshots,
    CreateSnapshot,
    DeleteAllSnapshots,
    DeleteSnapshotsByName,
    
    //Analytic
    GetGlobalTopRiders
}